module.exports = __webpack_public_path__ + "static/media/3DPPA34.97c6966e.jpg";